export const actionTypes = {
    SET_SHOW_INTERNAL_TAB_LIMIT_SETTING: 'operationalParameters_v2/SET_SHOW_INTERNAL_TAB_LIMIT_SETTING',
    SET_CLICKED_CONFIG_KPI: 'operationalParameters_v2/SET_CLICKED_CONFIG_KPI',
    SET_INTERNAL_ACTIVE_TAB: 'operationalParameters_v2/SET_INTERNAL_ACTIVE_TAB'
};

export const internalTabIDs = {
    operationalParameters: 'operationalParameters',
    energyRelatedSignals: 'energyRelatedSignals'
};
